module.exports = __webpack_public_path__ + "static/media/monster_purple.80c9d045.png";